export function isArrayOfStrings<T extends string>(arg: unknown): arg is T[] {
    if (!Array.isArray(arg)) {
        return false;
    }
    return !!arg && arg.filter((item) => typeof (item) !== 'string').length === 0;
}
